<template>
  <b-collapse v-model="isOpen" animation="slide" class="snack-queue">
    <template #trigger="propsQueue">
      <div class="header">
        <div class="simple-row">
          <div class="is-6 spacing-mr-5 has-text-weight-semibold">
            {{ titleHeader }}
          </div>
        </div>
        <section class="buttons">
          <span class="is-clickable">
            <b-icon :icon="propsQueue.open ? 'chevron-down' : 'chevron-up'" />
          </span>
          <span v-if="canClose" class="is-clickable" @click="close">
            <b-icon icon="close" />
          </span>
        </section>
      </div>
    </template>
    <div class="item">
      <component
        :is="component"
        v-if="component"
        v-bind="props"
        class="container-mobile"
        @updateTitle="updateTitle"
      />
    </div>
  </b-collapse>
</template>

<script>
export default {
  name: "SnackQueue",
  props: {
    title: {
      type: String,
      default: ""
    },
    component: [Object, Function, String],
    props: {
      type: Object,
      default: () => {}
    },
    closeSnack: {
      type: Function,
      default: () => null
    },
    closeAction: {
      type: Function,
      default: () => null
    }
  },
  data() {
    return {
      isOpen: true,
      canClose: false,
      titleHeader: this.title
    };
  },
  methods: {
    action() {
      this.close();
    },

    updateTitle(newTitle) {
      this.titleHeader = newTitle;
    },

    close() {
      this.closeAction(this.props);
      this.closeSnack();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.snack-queue {
  background-color: $white;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  z-index: 9999;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: $blue-dark;
  color: $white;
  padding: 10px 15px;
}
</style>
